import React from "react";
import "./ImpactTable.css";
import AppConfig from "../../../config/AppConfig";
import moment from "moment-timezone";
import {FileUtils} from "../../../utils/fileUtils";

import FallbackImage from  "../../../assets/base_map_impact.png";


export class ImpactTable extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            todaySelectedForecastStart: this.props.form.cst,
            todaySelected: this.props.form.cst,
            todayAnimationEnabled: true,
            todaySelectedPreloadedImages: [],
            todaySelectedFrame: null,

            tomorrowSelectedForecastStart: this.props.form.cst.clone().add(24, "hours"),
            tomorrowSelected: this.props.form.cst.clone().add(24, "hours"),
            tomorrowAnimationEnabled: true,
            tomorrowSelectedPreloadedImages: [],
            tomorrowSelectedFrame: null
        };

        this.intervals = {};
    }

    _getNumHoursSinceStart(startDt, currentDt){
        return currentDt.diff(startDt, "hours");
    }

    async _startAnimation(stateKey, enabledKey) {

        const totalFrames = 21;


        const todayUrls = FileUtils.generatePreloadImageUrls(
            this.props.form.cst,
            this.props.form.county.name,
            "Day0",
            this.props.form.size,
            this.props.form.fuel,
            totalFrames
        );

        const tomorrowUrls = FileUtils.generatePreloadImageUrls(
            this.props.form.cst,
            this.props.form.county.name,
            "Day1",
            this.props.form.size,
            this.props.form.fuel,
            totalFrames
        );

        const [todayImages, tomorrowImages] = await Promise.all([
            FileUtils.preloadImages(todayUrls),
            FileUtils.preloadImages(tomorrowUrls)
        ]);

        this.setState({todaySelectedPreloadedImages: todayImages, tomorrowSelectedPreloadedImages: tomorrowImages});

        const interval = setInterval(() => {
            if (this.state[enabledKey]) {
                this.setState(prev => {
                    const nextTime = prev[stateKey].clone().add(1, "hour");
                    const maxTime = prev[`${stateKey}ForecastStart`].clone().add(20, "hours");

                    if (nextTime.isBefore(maxTime)) {
                        return { [stateKey]: nextTime };
                    } else {
                        return { [stateKey]: prev[`${stateKey}ForecastStart`].clone() };
                    }
                });
            }
        }, 1000);

        this.intervals[stateKey] = interval;
    }

    _renderImpactTimeControls(startTimeCst, stateKey, enabledKey){

        const startCstFloored = startTimeCst;
        const endCstFloored = startCstFloored.clone().add(21, "hours");

        let options = [];

        for (let i = 0; i < 21; i++) {

            const optionTime = startCstFloored.clone().add(i, "hour")
            options.push(
                <option key={i} value={optionTime.toISOString()}>
                    {
                        optionTime
                            .clone()
                            .add(1, 'day')
                            .tz(AppConfig.time.displayTimezone)
                            .format("MM/DD/YYYY hh:mm A")
                    }
                </option>
            );

        }

        const clampAndSet = (newCst) => {
            if (newCst.isBetween(startCstFloored, endCstFloored.clone().subtract(1,"hour"), null, "[]")) {
                this.setState({ [stateKey]: newCst });
            }
        };

        return (
            <div className={"impact-time-control-group"}>

                <button
                    className={"impact-time-control"}
                    onClick={() => {
                        this.setState({[enabledKey]: !this.state[enabledKey]})
                    }}
                >
                    {this.state[enabledKey] ? this.props.i18n.Impact_Stop : this.props.i18n.Impact_Start}
                </button>

                <button
                    className={"impact-time-control"}
                    onClick={() => {
                        clampAndSet(this.state[stateKey].clone().subtract(1, "hour"));
                    }}
                >
                    {this.props.i18n.Impact_Decrement}
                </button>
                <select
                    className={"impact-time-control"}
                    value={this.state[[stateKey]].toISOString()}
                    onChange={(e) => {
                        this.setState({[[stateKey]]: moment(e.target.value)})
                    }}
                >
                    {options}
                </select>

                <span  className={"impact-time-control"}>
                    {this.props.i18n.Impact_Central_Time}
                </span>

                <button
                    className={"impact-time-control"}
                    onClick={() => {
                        clampAndSet(this.state[[stateKey]].clone().add(1, "hour"));
                    }}
                >
                    {this.props.i18n.Impact_Increment}
                </button>

            </div>
        );

    }



    componentDidMount() {

        Object.values(this.intervals).forEach(clearInterval);
        this.intervals = {};

        this._startAnimation("todaySelected", "todayAnimationEnabled");
        this._startAnimation("tomorrowSelected", "tomorrowAnimationEnabled");
    }

    componentWillUnmount() {
        Object.values(this.intervals).forEach(clearInterval);
        this.intervals = {};
    }

    componentDidUpdate(prevProps) {

        if (prevProps.form !== this.props.form) {

            Object.values(this.intervals).forEach(clearInterval);
            this.intervals = {};

            this.setState( {
                todaySelectedForecastStart: this.props.form.cst,
                todaySelected: this.props.form.cst,
                todayAnimationEnabled: true,
                todaySelectedPreloadedImages: [],
                todaySelectedFrame: null,
                tomorrowSelectedForecastStart: this.props.form.cst.clone().add(24, "hours"),
                tomorrowSelected: this.props.form.cst.clone().add(24, "hours"),
                tomorrowAnimationEnabled: true,
                tomorrowSelectedPreloadedImages: [],
                tomorrowSelectedFrame: null
            });

            this._startAnimation("todaySelected", "todayAnimationEnabled");
            this._startAnimation("tomorrowSelected", "tomorrowAnimationEnabled");
        }
    }

    render() {

        return (
            <table className="impact-table" cellPadding="0" cellSpacing="0">
                <thead className="impact-table-head">

                <tr>
                    <th colSpan={2} className={"impact-table-header"}>
                        {this.props.i18n.Contribution_Table_Header}
                    </th>
                </tr>

                <tr className={"impact-table-header"}>
                    <th className={"impact-table-subheader"}>
                        {
                            this.props.form.cst
                                .clone()
                                .add(1, "day")
                                .format(AppConfig.time.displayDateFormat)
                        }
                    </th>
                    <th className={"impact-table-subheader"}>
                        {
                            this.props.form.cst
                                .clone()
                                .add(2, "day")
                                .format(AppConfig.time.displayDateFormat)
                        }
                    </th>
                </tr>

                <tr className="impact-table-potential">
                    <th colSpan={2}>
                        {
                            this.props.i18n.Impact_County_Subheader +
                            this.props.form.county.displayName +
                            this.props.i18n.Impact_County
                        }
                    </th>
                </tr>
                </thead>

                <tbody>
                    <tr>
                        <th className={"impact-inner-column"}>
                            {
                                this._renderImpactTimeControls(
                                    this.props.form.cst,
                                    "todaySelected",
                                    "todayAnimationEnabled"
                                )
                            }
                            {this.state.todaySelectedPreloadedImages ? (
                                <img
                                    className="map-img-animation"
                                    src={this.state.todaySelectedPreloadedImages[
                                        this._getNumHoursSinceStart(this.state.todaySelectedForecastStart, this.state.todaySelected)]
                                    }
                                    alt=""
                                    onError={(e) => {
                                        e.currentTarget.onerror = null; // prevent infinite loop
                                        e.currentTarget.src = FallbackImage;
                                    }}
                                />
                            ) : null}

                        </th>

                        <th className={"impact-inner-column"}>
                            {
                                this._renderImpactTimeControls(
                                    this.props.form.cst.clone().add(1, "day"),
                                    "tomorrowSelected",
                                    "tomorrowAnimationEnabled"
                                )
                            }

                            {this.state.tomorrowSelectedPreloadedImages ? (
                                <img
                                    className="map-img-animation"
                                    src={this.state.tomorrowSelectedPreloadedImages[
                                        this._getNumHoursSinceStart(this.state.tomorrowSelectedForecastStart, this.state.tomorrowSelected)]
                                    }
                                    alt=""
                                    onError={(e) => {
                                        e.currentTarget.src = FallbackImage;
                                    }}
                                />
                            ) : null}

                        </th>

                    </tr>
                </tbody>

            </table>

        );
    }
}
